import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

function AdminLogs() {
    return (
        <div className="p-6">
            <Title level={2}>System Logs</Title>
            <Card>
                <p>System logs functionality coming soon...</p>
            </Card>
        </div>
    );
}

export default AdminLogs;